export const CONSULTORIO_CONNECTION_BLOCKING_REASON = {
  CONSULTORIO_DIGITAL: 'CONSULTORIO_DIGITAL',
  NO_PUBLISHED_IN_OSDE_CARTILLA: 'NO_PUBLISHED_IN_OSDE_CARTILLA'
};

export const CONSULTORIO_CONNECTION_BLOCKING_COPY = {
  [CONSULTORIO_CONNECTION_BLOCKING_REASON.CONSULTORIO_DIGITAL]: {
    bannerTitle: 'Conexión de agendas no habilitada',
    bannerBody:
      'Tu código de prestador no admite la conexión de agendas porque se encuentra vinculado a Consultorio Digital. Para obtener más información, podés enviar tu consulta desde Extranet ingresando a Herramientas / Mis trámites / Envío de consultas, motivo Cartilla.',
    modalTitle: 'No es posible realizar la solicitud',
    modalLead:
      'El código de prestador seleccionado no admite la conexión de agendas porque se encuentra vinculado a Consultorio Digital.',
    modalHint:
      'Para obtener más información, podés enviar tu consulta desde Extranet ingresando a Herramientas / Mis trámites / Envío de consultas, motivo Cartilla.'
  },
  [CONSULTORIO_CONNECTION_BLOCKING_REASON.NO_PUBLISHED_IN_OSDE_CARTILLA]: {
    bannerTitle: 'Conexión de agendas no habilitada',
    bannerBody:
      'El código de prestador seleccionado no admite la conexión de agendas porque no cuenta con consultorios publicados en la cartilla OSDE. Para obtener más información, podés enviar tu consulta desde Extranet ingresando a Herramientas / Mis trámites / Envío de consultas, motivo Cartilla.',
    modalTitle: 'No es posible realizar la solicitud',
    modalLead:
      'El código de prestador seleccionado no admite la conexión de agendas porque no cuenta con consultorios publicados en la cartilla OSDE.',
    modalHint:
      'Para obtener más información, podés enviar tu consulta desde Extranet ingresando a Herramientas / Mis trámites / Envío de consultas, motivo Cartilla.'
  }
};

export function resolveConsultorioConnectionBlockingReason(consultorioDigital) {
  if (!consultorioDigital) return null;
  if (consultorioDigital.blockingReason) return consultorioDigital.blockingReason;
  if (consultorioDigital.bloqueoPorConsultorioDigital) {
    return CONSULTORIO_CONNECTION_BLOCKING_REASON.CONSULTORIO_DIGITAL;
  }
  return null;
}

export function fallbackOsdeContratoPayload() {
  return {
    cuit: null,
    consultorioOsde: [],
    consultorioDigital: {
      bloqueoPorConsultorioDigital: false,
      blockingReason: CONSULTORIO_CONNECTION_BLOCKING_REASON.NO_PUBLISHED_IN_OSDE_CARTILLA
    },
    turnosFuturos: { tieneTurnos: false, cantidadTurnos: 0 }
  };
}
